import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { NftsEndpoint, NftTypeEndpoint, Url } from "../../Type/BaseUrl";

const NftTypeService = createApi({
	reducerPath: "NftTypeService",
	tagTypes: "nftdta",
	baseQuery: fetchBaseQuery({
		baseUrl: Url,
	}),
	endpoints: (builder) => {
		return {
			nftContent: builder.query({
				query: () => {
					return {
						url: NftTypeEndpoint,
						method: "GET",
					};
				},
				providesTags: ["nftdta"],
			}),

			nftsContent: builder.query({
				query: (datas) => {
					return {
						url: `${NftsEndpoint}?nft_type_id=${
							datas?.Nft_id ? datas?.Nft_id : ""
						}&page=${datas?.currentPageState ? datas?.currentPageState : 1}`,
						method: "GET",
					};
				},
				providesTags: ["nftdta"],
			}),
		};
	},
});
export const { useNftContentQuery, useNftsContentQuery } = NftTypeService;
export default NftTypeService;
